import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const ImgWrapper = styled.div`
  box-shadow:
    inset 0 -6px 6px -6px rgb(0 0 0 / 16%),
    inset 0 -3px 3px -6px rgb(0 0 0 / 23%);

  > * {
    max-width: var(--content-width);
    margin: 0 auto;
  }
`;

export default function Banner({ banner }) {
  const image = getImage(banner);
  return (
    <ImgWrapper id="top">
      <GatsbyImage image={image} alt="" />
    </ImgWrapper>
  );
}
